export const handleSince = (product, className) => {
	if (product.pharmacy !== undefined) {
		return <label className={className}> </label>;
	}
	return <label className={className}>Desde: </label>;
};
